export default "__VITE_ASSET__BWO60XRj__"